import APIService from 'services/APIService'

const api = APIService()

export const getLegislations = bpId =>
  api.get(`/building-passport/${bpId}/compliance/legislations`)

export const getLegislationProgramme = (bpId, framework) =>
  api.get(`/building-passport/${bpId}/compliance/programme`, { params: { framework } })

export const exportLegislationArchive = (bpId, framework) =>
  api.get(`/building-passport/${bpId}/compliance/legislation-archive`, {
    params: { framework }, responseType: 'blob',
  })

export const exportLegislationPack = (bpId, framework) =>
  api.get(`/building-passport/${bpId}/compliance/legislation-pack`, {
    params: { framework }, responseType: 'blob',
  })
